  import React, { useState, useEffect } from "react";
  import { useLocation, useNavigate } from "react-router-dom";
  import "../App.css";
  import 'bootstrap-icons/font/bootstrap-icons.css';
  import { sellFlight } from "./FareReviewPayloadRequest";

  const AirplaneLoader = () => (
    <div style={{
      position: "fixed", inset: 0, zIndex: 99999,
      background: "rgba(0,0,0,0.6)",
      display: "flex", alignItems: "center", justifyContent: "center"
    }}>
      <div style={{
        background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 50%, #0f172a 100%)",
        borderRadius: "20px",
        padding: "40px 48px",
        display: "flex", flexDirection: "column",
        alignItems: "center", gap: "28px",
        boxShadow: "0 25px 60px rgba(0,0,0,0.5)",
        minWidth: "380px"
      }}>
        <img
          src="/tripcaliber-logo.png"
          alt="TripCaliber Logo"
          style={{ width: "160px", filter: "brightness(0) invert(1)", opacity: 0.9 }}
        />

        <div style={{ position: "relative", width: "300px", height: "80px" }}>
          <div style={{
            position: "absolute", top: "0px", left: "0",
            width: "100%", display: "flex", justifyContent: "space-between",
            animation: "fadeCloud 1.5s ease-in-out infinite alternate"
          }}>
            <span style={{ fontSize: "22px", opacity: 0.4 }}>☁️</span>
            <span style={{ fontSize: "16px", opacity: 0.3 }}>☁️</span>
            <span style={{ fontSize: "24px", opacity: 0.4 }}>☁️</span>
          </div>
          <div style={{
            position: "absolute", top: "18px", fontSize: "36px",
            animation: "flyPlane 2s ease-in-out infinite alternate",
            filter: "drop-shadow(0 4px 12px rgba(99,179,237,0.5))"
          }}>✈️</div>
          <div style={{
            position: "absolute", bottom: "0", left: "0",
            width: "100%", height: "4px",
            background: "linear-gradient(90deg, transparent, #60a5fa, #3b82f6, #60a5fa, transparent)",
            borderRadius: "2px",
            animation: "glowLine 1.5s ease-in-out infinite alternate"
          }} />
        </div>

        <div style={{ textAlign: "center" }}>
          <p style={{
            color: "#fff", fontSize: "18px", fontWeight: 600,
            margin: 0, animation: "fadeText 1.5s ease-in-out infinite alternate"
          }}>
            We are going to next section...
          </p>
          <p style={{ color: "#93c5fd", fontSize: "13px", margin: "8px 0 0", opacity: 0.8 }}>
            Please wait while we prepare your booking
          </p>
          <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginTop: "14px" }}>
            {[0, 1, 2].map(i => (
              <div key={i} style={{
                width: "10px", height: "10px", borderRadius: "50%", background: "#3b82f6",
                animation: `dotBounce 1.2s ease-in-out ${i * 0.2}s infinite`
              }} />
            ))}
          </div>
        </div>

        <style>{`
          @keyframes flyPlane {
            0%   { left: 0px;   transform: translateY(0px) rotate(5deg); }
            100% { left: 255px; transform: translateY(-12px) rotate(-3deg); }
          }
          @keyframes glowLine {
            0%   { opacity: 0.5; }
            100% { opacity: 1; box-shadow: 0 0 12px #3b82f6; }
          }
          @keyframes fadeText {
            0%   { opacity: 0.7; }
            100% { opacity: 1; }
          }
          @keyframes fadeCloud {
            0%   { opacity: 0.3; transform: translateX(0); }
            100% { opacity: 0.6; transform: translateX(8px); }
          }
          @keyframes dotBounce {
            0%, 100% { transform: translateY(0); opacity: 0.4; }
            50%       { transform: translateY(-8px); opacity: 1; }
          }
        `}</style>
      </div>
    </div>
  );

  function FareRulesModal({ fare, flight, onClose }) {
    useEffect(() => {
      const onKeyDown = (e) => { if (e.key === "Escape") onClose(); };
      document.addEventListener("keydown", onKeyDown);
      return () => document.removeEventListener("keydown", onKeyDown);
    }, [onClose]);

    // Try the field names most commonly used by GDS/flight-API fare rule payloads.
    const rawRules =
      fare?.FareRules ||
      fare?.FareRuleText ||
      fare?.MiniRules ||
      flight?.FareRules ||
    flight?.FareGroups?.FareGroup?.[0]?.DateChange ||
      null;

    const rulesText = Array.isArray(rawRules) ? rawRules.join("\n\n") : rawRules;

    const cancellationFee = fare?.CancellationFee ?? fare?.PenaltyAmount ?? null;
    const changeFee = fare?.ChangeFee ?? fare?.DateChangeFee ?? null;

    return (
      <div
        style={{
          position: "fixed", inset: 0, zIndex: 99998,
          background: "rgba(15,23,42,0.55)",
          display: "flex", alignItems: "center", justifyContent: "center",
          padding: "20px",
        }}
        onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <div
          style={{
            background: "#fff", borderRadius: "14px", width: "100%", maxWidth: "560px",
            maxHeight: "80vh", display: "flex", flexDirection: "column",
            boxShadow: "0 25px 60px rgba(0,0,0,0.35)", overflow: "hidden",
          }}
        >
          <div style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "16px 20px", borderBottom: "1px solid #E8EAF0",
          }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: "#14213D" }}>
              <i className="bi bi-info-circle" style={{ marginRight: 8 }} /> Fare Rules
            </span>
            <button
              type="button"
              aria-label="Close fare rules"
              onClick={onClose}
              style={{
                border: "none", background: "transparent", fontSize: 20,
                lineHeight: 1, cursor: "pointer", color: "#6B7280", padding: 4,
              }}
            >
              ✕
            </button>
          </div>

          <div style={{ padding: "18px 20px", overflowY: "auto", fontSize: 13.5, color: "#374151", lineHeight: 1.6 }}>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
              <span style={{
                background: fare?.Refundable ? "#E6F4EA" : "#FFF3E0",
                color: fare?.Refundable ? "#27600A" : "#854F0B",
                padding: "4px 10px", borderRadius: 20, fontSize: 12, fontWeight: 600,
              }}>
                {fare?.Refundable ? "Refundable" : "Partially Refundable"}
              </span>
              {cancellationFee != null && (
                <span style={{ background: "#F0F1F5", color: "#374151", padding: "4px 10px", borderRadius: 20, fontSize: 12 }}>
                  Cancellation fee: ₹{Number(cancellationFee).toLocaleString("en-IN")}
                </span>
              )}
              {changeFee != null && (
                <span style={{ background: "#F0F1F5", color: "#374151", padding: "4px 10px", borderRadius: 20, fontSize: 12 }}>
                  Date change fee: ₹{Number(changeFee).toLocaleString("en-IN")}
                </span>
              )}
            </div>

            {rulesText ? (
              <div style={{ whiteSpace: "pre-line" }}>{rulesText}</div>
            ) : (
              <div style={{ color: "#9295A4" }}>
                Detailed fare rules aren't available from the airline for this fare at the moment.
                Standard airline cancellation and date-change penalties apply — please confirm exact
                charges with the airline or during checkout before booking.
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  export default function FareDetails() {
    const [loading, setLoading] = useState(false);
    const [showFareRules, setShowFareRules] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    // API Data extraction
    const flight = location.state?.flight;
    const segment = flight?.AirSegments?.[0];
    const fare = flight?.AirlineFare 
      || flight?.AirlineFares?.find(f => f.ContractType === "Onword")
      || flight?.AirlineFares?.[0] 
      || {};

    const apiToken = location.state?.apiToken;
    const agencyKey = location.state?.agencyKey;
    const bookingKey = location.state?.bookingKey;
    const passengers = location.state?.passengers || [];

    const adultCount = location.state?.AdultCount || flight?.AdultCount || 1;
    const childCount = location.state?.ChildCount || 0;
    const infantCount = location.state?.InfantCount || 0;

    // Plain INR formatting — no currency conversion.
    const formatPrice = (inrAmount) => {
      const amt = Number(inrAmount || 0);
      return <>₹{amt.toLocaleString("en-IN")}</>;
    };

    if (!flight) {
      return <div style={{ padding: "50px", textAlign: "center" }}>No Flight Data Found</div>;
    }

    const handleContinue = async () => {
      setLoading(true);
      try {
        const data = await sellFlight(flight, apiToken, agencyKey, bookingKey);

        if (!data || data.ResponseStatus !== 1) {
          alert("Sell failed: " + (data?.Error?.ErrorDesc || "Unknown error"));
          setLoading(false);
          return;
        }

        const freshBookingKey = data?.BookingKey || data?.Sell?.BookingKey || bookingKey;

        navigate("/FlightReview", {
          state: { 
            sellResponse: data,
            flight: {
              ...flight,
              IsInternational: !flight?.IsDomestic,
              AdultCount: adultCount,
              ChildCount: childCount,
              InfantCount: infantCount,
              BookingKey: freshBookingKey
            },
            apiToken,
            agencyKey,
            bookingKey: freshBookingKey
          }
        });
      } catch (err) {
        console.error("Sell Error:", err);
        alert("Something went wrong while fetching fare details.");
      } finally {
        setLoading(false);
      }
    };

    // Helper formatting functions
    const formatFullDate = (d) => new Date(d).toLocaleDateString('en-GB', { weekday: 'short', day: '2-digit', month: 'short', year: '2-digit' });
    const formatShortDate = (d) => new Date(d).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' }).toUpperCase();
    const formatTime = (d) => new Date(d).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });

    const segments = flight?.AirSegments || [];

    return (
      <div className="fare-details-page">
        {loading && <AirplaneLoader />}
        {showFareRules && (
          <FareRulesModal fare={fare} flight={flight} onClose={() => setShowFareRules(false)} />
        )}

        <div style={{ display: "flex", gap: "25px", flexWrap: "wrap" }}>
          {/* LEFT COLUMN */}
          <div style={{ flex: "2", minWidth: "650px" }}>
            {segments.map((segment, idx) => (
              <div className="view_box" key={idx}>
                <div className="flight_preview">
                  <div className="flight_preview_head">
                    <div className="left">
                      <span className="city">
                        <span>Onword</span> &nbsp;&nbsp;
                        <b>{segment?.Origen} <i className="bi bi-arrow-right"></i> {segment?.Destination} </b>
                      </span>
                      <span className="jurney">
                        {formatShortDate(segment?.DepartureDateTime)} | {segments.length <= 1 ? "0 Stop" : `${segments.length - 1} Stop`} | {segment?.Duration}
                      </span>
                    </div>
                  </div>

                  <div className="flight_preview_details">
                    <div className="flight_col1">
                      <div className="f_img">
                        <img  src={`/Flight_Images/${segment?.AirlineCode}.gif`} alt={segment?.AirlineName} />
                      </div>
                      <div>
                        <span className="flight_name">{segment?.AirlineName}</span>
                        <span className="flight_num">{segment?.AirlineCode}-{segment?.FlightNumber}</span>
                      </div>
                    </div>
                    <div className="flight_col2">
                      <span className="t1">Travel Class</span>
                      <span className="t2">{segment?.CabinClass || "Economy"}</span>
                    </div>
                    <div className="flight_col2">
                      <span className="t1">Check-In Baggage</span>
                      <span className="t2">Adult - {segment?.BaggageAllowed?.CheckInBaggage || "15 Kg"} (01 Piece only)</span>
                    </div>
                    <div className="flight_col2">
                      <span className="t1">Cabin Baggage</span>
                      <span className="t2">Adult - {segment?.BaggageAllowed?.HandBaggage || "7 Kg"}</span>
                    </div>
                  </div>

                  <div className="flight_preview_content">
                    <div className="from">
                      <span className="time">{formatTime(segment?.DepartureDateTime)}</span>
                      <span className="date">{formatFullDate(segment?.DepartureDateTime)}</span>
                      <span className="l1">{segment?.SourceCity} <b>[{segment?.Origen}]</b></span>
                    </div>
                    <div className="duration">
                      <span className="t_time">{segment?.Duration}</span>
                      <span className="t_arrow"><i className="fa fa-plane"></i></span>
                    </div>
                    <div className="to">
                      <span className="time">{formatTime(segment?.ArrivalDateTime)}</span>
                      <span className="date">{formatFullDate(segment?.ArrivalDateTime)}</span>
                      <span className="l1">{segment?.DestinationCity} <b>[{segment?.Destination}]</b></span>
                      <span className="l1">{segment?.Terminal ? `Terminal ${segment.Terminal}` : ""}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <div className="row">
              <div className="col-sm-6">
                <span className="section_title">Onword</span>
              </div>
            </div>

            <div className="fare_wrap">
              <div className="fare_box">
                <input type="hidden" id="FareGroupid" value="623" />
                <input type="hidden" id="SegmentType" value="Onword" />

                <label htmlFor="fare-option-o-1-623" className="fare_rbtnlbl">
                  <span className="fare_title">VALUE</span>
                  <span className="fare">{formatPrice(fare?.GrossFare)}</span>
                  <span className="fare_desc">
                    Standard airline cancellation and date change penalties apply
                  </span>
                  <div className="right">
                    <div className="fare_actions">
                      <span className="partially-refundable">
                        {fare?.Refundable ? "Refundable" : "Partially Refundable"}
                      </span>
                      <button
                        type="button"
                        className="btn_farerules btn-fareruleBtn"
                        onClick={() => setShowFareRules(true)}
                      >
                        Fare Rules <i className="bi bi-info-circle"></i>
                      </button>
                    </div>
                  </div>
                </label>
              </div>
            </div>

            <div className="view_box">
              <div className="flight_preview">
                <div className="flight_preview_head">
                  <div className="left">
                    <span className="title">🔒 Log-in to your TripCaliber Account</span>
                  </div>
                  <div className="right">
                    <button className="link_login">Log In</button>
                    <button className="btn_loginguest" onClick={handleContinue}>
                      Continue as Guest
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ flex: "1", minWidth: "320px" }}>
            <div className="right_section">
              <span className="section_title">Fare Summary</span>
              {passengers && passengers.length > 0 && (
                <div className="traveller_section">
                  <span className="sub_title">Traveller Details</span>
                  {passengers.map((pax, index) => (
                    <div className="traveller_card" key={index}>
                      <div className="traveller_row">
                        <span className="traveller_name">
                          {pax.Title} {pax.FirstName} {pax.LastName}
                        </span>
                        <span className={`pax_badge ${pax.PaxType === 1 ? "adult" : pax.PaxType === 2 ? "child" : "infant"}`}>
                          {pax.PaxType === 1 ? "Adult" : pax.PaxType === 2 ? "Child" : "Infant"}
                        </span>
                      </div>
                      {pax.DateOfBirth && (
                        <div className="traveller_info">
                          <span>DOB:</span> <span>{pax.DateOfBirth}</span>
                        </div>
                      )}
                      {pax.PassportNo && (
                        <div className="traveller_info">
                          <span>Passport:</span> <span>{pax.PassportNo}</span>
                        </div>
                      )}
                      {pax.ContactNo && (
                        <div className="traveller_info">
                          <span>Contact:</span> <span>{pax.ContactNo}</span>
                        </div>
                      )}
                      {pax.Email && (
                        <div className="traveller_info">
                          <span>Email:</span> <span>{pax.Email}</span>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

            {adultCount > 0 && (
        <div className="price_panel">
          <span className="titel">
            Adult × {adultCount} Child x{childCount} (BaseFare)
          </span>
          <span className="price">
            {formatPrice(fare?.BaseFare)}
          </span>
        </div>
      )}
      {infantCount > 0 && (
        <div className="price_panel">
          <span className="titel">
            Infant × {infantCount}
          </span>
          <span className="price">
            {formatPrice(fare?.InfantBaseFare)}
          </span>
        </div>
      )}
              <div className="price_panel">
                <span className="titel">Tax</span>
                <span className="price">{formatPrice(fare?.TaxFare || fare?.Tax)}</span>
              </div>

              <div className="price_panel">
                <span className="titel">Discount</span>
                <span className="price">- {formatPrice(fare?.Discount)}</span>
              </div>

              <div className="f_total">
                <span>Total Fare</span>
                <span>{formatPrice(fare?.GrossFare || (Number(fare?.BaseFare || 0) + Number(fare?.TaxFare || fare?.Tax || 0)))}</span>
              </div>

              <div className="price_panel">
                <span className="titel">Add-Ons</span>
                <span className="price">{formatPrice(fare?.AdditionalCharges)}</span>
              </div>

              <div className="pay_total">
                <span>You Pay :</span>
                <span>{formatPrice(fare?.GrossFare || (Number(fare?.BaseFare || 0) + Number(fare?.TaxFare || fare?.Tax || 0)))}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }